import React, { useState } from 'react';
import { ResultItem, ResultsList, SearchContainer, SearchDiv, SearchInput } from './styles';

import SearchIcon from '@mui/icons-material/Search';

interface ContentIndex {
  url: string;
  title?: string;
  content: string;
}

interface SearchProps {
  data: ContentIndex[];
}

const Search: React.FC<SearchProps> = ({ data }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<ContentIndex[]>([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    setQuery(searchTerm);

    if (searchTerm.length > 0) {
      const filteredResults = data.filter((item: any) =>
        item.content.toLowerCase().includes(searchTerm) || item.title.toLowerCase().includes(searchTerm)
      );
      setResults(filteredResults);
    } else {
      setResults([]);
    }
  };

  const handleClick = () => {
    setShowResults(!showResults);
  }

  return (
    <SearchContainer style={{zIndex: '1' }}>
      <SearchDiv>
        <SearchInput
          type="text"
          value={query}
          onChange={handleSearch}
          placeholder="Digite sua busca..."
          style={{ color: "white" }}
        />
        <SearchIcon
          style={{display: 'flex', marginLeft: '-40px', color: 'white', alignItems: 'center', marginTop: '7px', cursor: 'pointer'}}
          onClick={handleClick}
          />
      </SearchDiv>

      <ResultsList>
        {showResults && results.map((result) => (
          <ResultItem  key={result.url}>
            <a href={result.url} onClick={() => setResults([])}>
              <h3>{result.title}</h3>
              <p>{result.content}</p>
              
              </a>
          </ResultItem >
        ))}
      </ResultsList>
    </SearchContainer>
  );
};

export default Search;
